
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.7 25.27a3.17 3.17 0 116.33 0V39","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M20.38 25.27v-4.22a3.16 3.16 0 116.32 0V39","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M33 31.59a3.16 3.16 0 016.32 0v21.08A6.32 6.32 0 0133 59H17.21C15.47 59 4.56 46 4.56 44.24a3.16 3.16 0 013.17-3.16c1.74 0 4.21 2.11 6.32 4.22v-20a3.17 3.17 0 116.33 0V39M45.59 9.43a3.17 3.17 0 116.33 0v13.7","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M39.27 9.43V5.21a3.16 3.16 0 016.32 0v17.92","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M32.94 24.86V9.43a3.17 3.17 0 116.33 0v13.7M51.92 15.75a3.16 3.16 0 016.32 0v21.08a6.32 6.32 0 01-6.32 6.33H39.49M1.62 1.86l11.35 11.35M18.48 1v8.97M.76 18.72h8.97","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    